import { Box } from '@mui/material';
import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import UserGridSkeleton from './StyledSkeleton';
import { FC } from 'react';
import StyledDataGrid from './StyledDataGrid';
import SkeletonPagination from './LoadingPagination';

interface LoadingTableProps {
  columns: GridColDef[];
}

const LoadingTable: FC<LoadingTableProps> = ({ columns }) => {
  const skeletonRows = Array.from({ length: 12 }, (_, index) => ({
    id: index + 1,
    ...Object.fromEntries(columns.map((col) => [col.field, ''])),
  }));

  const renderSkeletonCell = (params: GridCellParams) => {
    let width = '50%';
    let height = '20%';
    let borderRadius = '5px';
    let border = '';

    if (
      params.field !== 'action' &&
      params.field !== 'role' &&
      params.field !== 'number' &&
      params.field !== 'displayOrder' &&
      params.field != 'date'
    ) {
      const randomWidth = Math.floor(Math.random() * 41) + 50;
      width = `${randomWidth}%`;
    }

    if (params.field === 'status') {
      width = '70px';
      height = '40px';
      borderRadius = '19px';
    }
    if (params.field === 'accountType') {
      width = '65px';
      height = '40px';
      borderRadius = '10px';
      border = '2px solid #ccc';
    }
    if (params.field === 'action') {
      width = '20%';
    }
    if (params.field === 'date') {
      width = '65%';
    }
    if (
      params.field === 'availableQty' ||
      params.field === 'minLevelQty' ||
      params.field === 'displayOrder'
    ) {
      width = '30%';
    }
    if (params.field === 'unit' || params.field === 'unitPrice') {
      width = '50%';
    }

    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent:
            params.field === 'status' ||
            params.field === 'action' ||
            params.field === 'number' ||
            params.field === 'unitPrice' ||
            params.field === 'availableQty' ||
            params.field === 'displayOrder' ||
            params.field === 'accountType'
              ? 'center'
              : 'left',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <UserGridSkeleton width={width} height={height} sx={{ borderRadius }} />
      </Box>
    );
  };

  const skeletonColumns: GridColDef[] = columns.map((col) => ({
    ...col,
    renderCell: renderSkeletonCell,
  }));

  return (
    <Box
      height="calc(100vh - 64px)"
      bgcolor="var(--bg-color)"
      maxHeight="750px"
      width="100%"
      sx={{
        overflowX: 'hidden',
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      <Box
        height="700px"
        width="auto"
        margin="0 auto"
        sx={{
          overflowX: 'hidden',
          overflowY: 'scroll',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <StyledDataGrid
          rows={skeletonRows}
          columns={skeletonColumns}
          disableColumnMenu
        />
      </Box>
      <SkeletonPagination />
    </Box>
  );
};

export default LoadingTable;
